const route = {
	name: 'job-profile',
	path: 'profile',
	component: () => import('@/modules/job-profile/pages/page-profiles'),
	meta: {
		title: 'Perfil de Puestos',
	},
	props: true,
	children: [
		{
			name: 'new-profile',
			path: 'new-profile',
			component: () => import('@/modules/job-profile/pages/page-new-profile'),
			meta: {
				title: 'Perfil de Puestos',
			},
		},
		{
			name: 'job-description',
			path: 'job-description/:id',
			component: () => import('@/modules/job-profile/pages/page-description-job'),
			meta: {
				title: 'Descripción de Puestos',
			},
			redirect: 'job-description/mission',
			children: [
				{
					name: 'job-mission',
					path: 'mission',
					component: () => import('@/modules/job-profile/pages/first-page/job-mission'),
					meta: {
						title: 'Misión del Puesto',
					},
				},
				{
					name: 'job-activities',
					path: 'activities',
					component: () => import('@/modules/job-profile/pages/second-page/job-activities'),
					meta: {
						title: 'Actividades de Puesto',
					},
				},
				{
					name: 'job-required-knowledge',
					path: 'required-knowledge',
					component: () => import('@/modules/job-profile/pages/third-page/job-required-knowledge'),
					meta: {
						title: 'Conocimientos Requeridos',
					},
				},
				{
					name: 'job-formal-instructions',
					path: 'formal-instructions',
					component: () => import('@/modules/job-profile/pages/fourth page/job-formal-instructions'),
					meta: {
						title: 'Instrucción Formal',
					},
				},
				{
					name: 'job-required-experience',
					path: 'required-experience',
					component: () => import('@/modules/job-profile/pages/experience-page.vue/job-required-work-experience'),
					meta: {
						title: 'Experiencia Laboral Requerida',
					},
				},
				{
					name: 'job-measurable-commitments',
					path: 'measurable-commitments',
					component: () => import('@/modules/job-profile/pages/commitments-page/job-measurable-commitments'),
					meta: {
						title: 'Compromisos Medibles',
					},
				},
				{
					name: 'job-required-skills',
					path: 'required-skills',
					component: () => import('@/modules/job-profile/pages/fifth-page/job-required-skills'),
					meta: {
						title: 'Destrezas Requeridas',
					},
				},
				{
					name: 'job-required-competencies',
					path: 'required-competencies',
					component: () => import('@/modules/job-profile/pages/sixth-page/job-required-competencies'),
					meta: {
						title: 'Competencias Requeridas',
					},
				},
				{
					name: 'job-results-indicators',
					path: 'results-indicators',
					component: () => import('@/modules/job-profile/pages/seventh-page/job-results-indicators'),
					meta: {
						title: 'Indicadores de Resultado',
					},
				},
			],
		},
		{
			name: 'job-description-details',
			path: 'description-details/:id',
			component: () => import('@/modules/job-profile/pages/page-job-description-details'),
			meta: {
				title: 'Detalle Descripción de Puestos',
			},
			redirect(to) {
				return {
					name: 'job-view-details',
					params: to.params,
				};
			},
			children: [
				{
					name: 'job-view-details',
					path: 'view-details',
					component: () => import('@/modules/job-profile/pages/details-job-description/details-job-description'),
					meta: {
						title: 'Detalle',
					},
				},
			],
		},
	],
};
export default route;



// WEBPACK FOOTER //
// ./src/modules/job-profile/router/index.js